// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes shimmer-loading--HbPb1{0%{background-position:200% 0}100%{background-position:-200% 0}}.slide-meta--Wt8vh{position:relative;margin-right:0;margin-left:0;padding-top:5px;padding-bottom:5px;width:100%;min-height:36px;z-index:2}.slide-meta--Wt8vh .slide-meta-overlay{position:absolute;top:0;right:0;bottom:0;left:0;padding:0;height:100%;border-radius:0}.slide-meta--Wt8vh .blur-text-bkg--fZz_I{backdrop-filter:blur(10px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"slide-meta": "slide-meta--Wt8vh",
	"blur-text-bkg": "blur-text-bkg--fZz_I",
	"shimmer-loading": "shimmer-loading--HbPb1"
};
export default ___CSS_LOADER_EXPORT___;
